import { SelectableTagInterface } from "@api/models/interfaces/SelectableTagInterface";
import Vue from "vue";

export class TagsFilterState {

    constructor(
        /**
         * source tags that can be shown
         */
        public sourceTags: SelectableTagInterface[],
        public eventName: string) {
    }

    /**
     * tags for apply
     */
    public tags: SelectableTagInterface[] | undefined;

    /**
     * accumulated tags ids for possible filtering
     */
    acumulatedTagsIds: string[] = [];

    public clear() {
        this.clearTagsState();
        this.clearAccumulated();
    }


    public setTags() {
        Vue.set(this, "tags", this.sourceTags.filter((item) => item.isVisible));
    }

    /**
     * Adding and removing tags from the accumulated list
     * and toggling selected state
     * @param tag
     */
    public accumulateTag(tag: SelectableTagInterface) {
        if (!tag.isSelected) {
            this.addToAccumulated(tag)
        } else {
            this.removeFromAccumulated(tag)
        }

        tag.isSelected = !tag.isSelected;
    }

    /**
     * updating source tags
     */
    public updateSource(soureTags: SelectableTagInterface[], sourceTagsIds: Set<string> | null, selectedTags: string[]) {
        this.sourceTags = soureTags
            .map((tag) => {
                return {
                    ...tag,
                    isVisible: sourceTagsIds ? sourceTagsIds.has(tag.tag.id) : true,
                    isSelected: selectedTags.includes(tag.tag.id)
                }
            })
    }

    /**
     * accumulated tags manipulation
     * @param tag To accumulated
     */
    private addToAccumulated(tag: SelectableTagInterface) {
        this.acumulatedTagsIds.push(tag.tag.id);
    }

    /**
     * accumulated tags manipulation
     * @param tag from accumulated
     */
    private removeFromAccumulated(tag: SelectableTagInterface) {
        this.acumulatedTagsIds = this.acumulatedTagsIds.filter(id => id !== tag.tag.id);
    }

    private clearTagsState() {
        this.tags?.forEach(tag => tag.isSelected = false)
    }

    private clearAccumulated() {
        this.acumulatedTagsIds = [];
    }
}